import React from 'react'
import ContentList from './contentList.js'
import { client } from '../util/client.js'

const queryFilms = `*[_type == "movie"] | order(releaseDate desc)`

class Films extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      films: []
    }
  }
  componentDidMount() {
    client
      .fetch(queryFilms)
      .then(res => {
        this.setState({
          films: res
        })
      })
      .catch(err => {
        console.log('error', err)
      })

  }
  render() {
    const {
      films
    } = this.state
    return (
      <ContentList content={films} contentType='films' />
    )
  }
}

export default Films